export const API_VERSION = 'v1';
export const BASE_TITLE = 'Vaazme App';
export const BASE_URL = `${process.env.REACT_APP_API_HOST}/api/v1/vaazme`;
export const BASE_MOCK_URL = `${process.env.REACT_APP_API_MOCK_HOST}/api/v1/vaazme`;
export const TIMEOUT = 50000;
